(() => {
    const initQuantitySelectors = (scope = document) => {
      scope.querySelectorAll('[data-main-product-v2-quantity-selector]').forEach((root) => {
        if (root.dataset.mainProductV2QuantityBound === 'true') return;
        const productInfo = root.closest('product-info');
        const badge = root.querySelector('[data-main-product-v2-quantity-badge]');
        const applyQuantity = (button, emit = true) => {
          const quantity = Number(button.dataset.mainProductV2QuantityOption || 1);
          const hasPromotion = Boolean(button.dataset.mainProductV2PromotionLabel);
          root.querySelectorAll('[data-main-product-v2-quantity-option]').forEach((item) => {
            const isSelected = item === button;
            item.classList.toggle('main_product_v2__quantity-selector-option--selected', isSelected);
            item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          });
          const promotionLabel = button.dataset.mainProductV2PromotionLabel || '';
          const badgeLabel = badge?.querySelector('[data-main-product-v2-quantity-badge-label]');
          if (badgeLabel) badgeLabel.textContent = promotionLabel;
          badge.hidden = !promotionLabel;
          badge.classList.toggle('main_product_v2__quantity-selector-badge--active', quantity > 1 && hasPromotion);
          if (productInfo) {
            productInfo.dataset.mainProductV2Quantity = quantity;
            if (emit) productInfo.dispatchEvent(new CustomEvent('main-product-v2:quantity-change', { bubbles: true, detail: { quantity, promotionLabel: button.dataset.mainProductV2PromotionLabel || '' } }));
          }
        };
        const initial = Array.from(root.querySelectorAll('[data-main-product-v2-quantity-option]')).find((button) => Number(button.dataset.mainProductV2QuantityOption) === Number(root.dataset.defaultQuantity || 1)) || root.querySelector('[data-main-product-v2-quantity-option]');
        if (initial) applyQuantity(initial);
        root.querySelectorAll('[data-main-product-v2-quantity-option]').forEach((button) => button.addEventListener('click', () => applyQuantity(button)));
        root.dataset.mainProductV2QuantityBound = 'true';
      });
    };
    const start = () => initQuantitySelectors();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
    document.addEventListener('shopify:section:load', (event) => initQuantitySelectors(event.target));
  })();
